export const ALLOW_PLR_CODES = ['CSP', 'HI', 'EP'];
